export const GET_TRANSACTION = 'BIRTH_CERTIFICATES/get_transaction';
export const APPROVE_TRANSACTION = 'BIRTH_CERTIFICATES/approve_transaction';
export const UPDATE_TRANSACTION = 'BIRTH_CERTIFICATES/update_transaction';
export const SHOW_TRANSACTION = 'BIRTH_CERTIFICATES/show_transaction';
export const START_ASSESSMENT = 'BIRTH_CERTIFICATES/start_assessment';
export const GET_SETTINGS = 'BIRTH_CERTIFICATES/get_settings';
export const UPDATE_TEST_STATUS = 'BIRTH_CERTIFICATES/update_health_status';
export const GET_BIRTH_ARCHIVE =
  'BIRTH_CERTIFICATES/get_birth_certificates_arhive';
export const GET_PHOTO = 'BIRTH_CERTIFICATES/getPhoto';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const EDIT_BIRTH = 'BIRTH_CERTIFICATE/edit_birth';
export const UPDATE_REGISTRY = 'BIRTH_CERTIFICATE/update_registry';
export const MANUAL_PAYMENT_APPROVE =
  'BIRTH_CERTIFICATE/manual_payment_approve';
export const MANUAL_PAYMENT_REJECT = 'BIRTH_CERTIFICATE/manual_payment_reject';
export const GET_LOGS = 'BIRTH_CERTIFICATE/get_logs';

export const QR_VERIFIER = 'BIRTH_CERTIFICATE/qr_verifier';
export const CIVIL_REG_FILE_IMPORT_UPLOAD = 'CIVIL_REG_FILE_IMPORT_UPLOAD';
export const CIVIL_REG_FILE_IMPORT_LIST = 'CIVIL_REG_FILE_IMPORT/list';
export const APPLY_DISCOUNT = 'BIRTH_CERTIFICATE/apply_discount';
export const CANCEL_APPLICATION = 'BIRTH_CERTIFICATE/cancel_application';
export const CANCEL_ASSESSMENT = 'BIRTH_CERTIFICATE/cancel_assessment';

export const GET_PURPOSE_LIST = 'BIRTH_CERTIFICATE/get_purpose_list';

export const FORM_DATA = {
  // Owner's Personal Information
  first_name: '',
  middle_name: '',
  last_name: '',
  extension_name: '',
  gender: '',
  birth_date: '',

  // Owner's Father's Name
  fathers_first_name: '',
  fathers_middle_name: '',
  fathers_last_name: '',
  fathers_suffix_name: '',

  // Owner's Mother's Name
  mothers_first_name: '',
  mothers_middle_name: '',
  mothers_last_name: '',
  mothers_extension_name: '',

  // Requestor's Information
  tin_number: '',
  requestors_first_name: '',
  requestors_middle_name: '',
  requestors_last_name: '',
  requestors_suffix_name: '',
  relationship_to_the_owner: '',

  // Mailing Address
  region_code: '',
  province_code: '',
  municipality_code: '',
  barangay_code: '',
  street: '',
  mailing_zip_code: '',
  telephone_number: '',
  mobile_number: '',

  // Transactional Information
  born_abroad_country_code: '',
  bren: '',
  hospital_code: '',
  hospital_other: '',
  is_registered_late: '',
  registered_when: '',
  number_of_copies: '',
  what_to_print: '',
  purpose_code: '',
  purpose_specify: '',
  purpose_country_code: '',
  valid_id_to_present: 'OTHER',

  // NEED FOR VALIDATION ONLY
  place_of_birth_municipality_code: '',
  place_of_birth_province_code: '',
  place_of_birth_region_code: '',
};
